/* eslint-disable */
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { useEffect, useState } from "react";
import { saveAsColorLente } from "../../services/AsColorLenteService";
import WaitingDialog from "../../utils/WaitingDialog";
const initialState = {
  descripcion: "",
  observaciones: "",
};

const nameItemText = "Color de lente de anteojos de sol";
const itemGender = "M";
//
// ########################################################################### 
//
const AsColorLenteDialog = ({
  onSave,
  onClose,
  itemCrud,
  actionCrud,
  setMessage,
  setShowMessage,
}) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (actionCrud === "new") {
      setItemCrudLocal(initialState);
    } else {
      setItemCrudLocal(itemCrud);
    }
  }, []);
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleSave = () => {
    if (actionCrud === "new" || actionCrud === "update") {
      if (itemCrudLocal.descripcion === "") {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar la descripción del Color",
        });
        setShowMessage(true);
        return;
      }
    }
    save();
  };
  //
  // ########################################################################## 
  //
  const save = async () => {
    let _itemCrud = {
      descripcion: itemCrudLocal.descripcion,
      observaciones: itemCrudLocal.observaciones,
    };
    if (actionCrud !== "new") {
      _itemCrud.id = itemCrudLocal.id;
    }

    setIsDoingSomething(true);
    const response = await saveAsColorLente(actionCrud, _itemCrud);
    setIsDoingSomething(false);

    if (response.ok) {
      onSave();
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
          handleCloseDialog();
        }}
        disableEscapeKeyDown={true}
        maxWidth="sm"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {actionCrud === "new"
            ? itemGender === "M"
              ? "Nuevo"
              : "Nueva"
            : actionCrud === "update"
              ? "Editando"
              : actionCrud === "enable"
                ? "Habilitando"
                : "Deshabilitando"}{" "}
          {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="descripcion"
                label="Color"
                variant="outlined"
                size="small"
                name="descripcion"
                value={itemCrudLocal.descripcion}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                inputProps={{
                  autoComplete: "off"
                }}
                id="observaciones"
                label="Observaciones"
                variant="outlined"
                name="observaciones"
                value={itemCrudLocal.observaciones}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
                multiline
                rows={3}
                sx={{
                  "& .MuiInputBase-root": {
                    minHeight: '80px'
                  }
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Box
                sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}
              >
                <Button
                  sx={{ mr: 1 }}
                  variant="contained"
                  onClick={handleSave}
                  color={actionCrud === "disable" ? "error" : "primary"}
                  startIcon={
                    actionCrud === "disable" ? (
                      <RemoveCircleOutlineIcon />
                    ) : actionCrud === "enable" ? (
                      <AddCircleOutlineIcon />
                    ) : (
                      <SaveIcon />
                    )
                  }
                >
                  {actionCrud === "disable"
                    ? "Deshabilitar"
                    : actionCrud === "enable"
                      ? "Habilitar"
                      : "Guardar"}
                </Button>

                <Button
                  variant="outlined"
                  onClick={handleCloseDialog}
                >
                  Cancelar
                </Button>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog >

      < WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default AsColorLenteDialog;
